import { BUSINESS_FORM_CONFIG } from '@/utils/const/products/vod-assessment';
import { Form, Input, Radio, Tooltip } from 'antd';
import { Button } from 'antd-mobile';
import { useState } from 'react';
import Styles from '../index.module.scss';
import InfoTooltip from '../InfoTooltip';
import NumberInput from './NumberInput';

export enum FeeTypes {
  monthBandWidth95 = 'monthBandWidth95',
  flow = 'flow',
}
interface IProps {
  formValue: {
    feeType: FeeTypes;
    videoNumber: number;
    videoDuration: number;
    monthBandWidth95: number;
    flow: number;
  };
  onSubmit: Function;
}

const BusinessForm = ({ formValue, onSubmit }: IProps) => {
  const [form] = Form.useForm();
  const [currentFeeType, setCurrentFeeType] = useState(formValue.feeType);
  const feeTypeChange = (val) => {
    setCurrentFeeType(val.target.value);
  };

  // 开始计算
  const getAssessmentResult = async () => {
    const res = await form.validateFields();
    if (res) {
      onSubmit(res);
    }
  };

  return (
    <div className={Styles.formContainer}>
      <div className={Styles.formTitle}>
        {BUSINESS_FORM_CONFIG.formTitle}
        <InfoTooltip
          title={BUSINESS_FORM_CONFIG.formInfo}
          style={{ position: 'relative', top: -3 }}
        />
      </div>
      <Form form={form} layout="vertical" initialValues={formValue}>
        <Form.Item name="feeType">
          <Radio.Group onChange={feeTypeChange}>
            <Radio value="monthBandWidth95">
              {BUSINESS_FORM_CONFIG.feeTypeOptions.monthBandWidth95}
            </Radio>
            <Radio value="flow">
              {BUSINESS_FORM_CONFIG.feeTypeOptions.flow}
            </Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label={BUSINESS_FORM_CONFIG.formItemOptions.videoNumber.label}
          name="videoNumber"
          rules={[
            {
              required: true,
              message: BUSINESS_FORM_CONFIG.formItemOptions.videoNumber.message,
            },
          ]}
        >
          <NumberInput
            max={100000000}
            min={0}
            precision={2}
            suffix={BUSINESS_FORM_CONFIG.formItemOptions.videoNumber.suffix}
            style={{ width: '100%' }}
          />
        </Form.Item>
        <Form.Item
          label={BUSINESS_FORM_CONFIG.formItemOptions.videoDuration.label}
          name="videoDuration"
          rules={[
            {
              required: true,
              message:
                BUSINESS_FORM_CONFIG.formItemOptions.videoDuration.message,
            },
          ]}
        >
          <NumberInput
            max={1000}
            min={0}
            suffix={BUSINESS_FORM_CONFIG.formItemOptions.videoDuration.suffix}
            precision={1}
            style={{ width: '100%' }}
          />
        </Form.Item>
        {currentFeeType === FeeTypes.monthBandWidth95 && (
          <Form.Item
            label={BUSINESS_FORM_CONFIG.formItemOptions.monthBandWidth95.label}
            name="monthBandWidth95"
            rules={[
              {
                required: true,
                message:
                  BUSINESS_FORM_CONFIG.formItemOptions.monthBandWidth95.message,
              },
            ]}
          >
            <NumberInput
              max={1000000}
              min={0}
              suffix={
                BUSINESS_FORM_CONFIG.formItemOptions.monthBandWidth95.suffix
              }
              precision={2}
              style={{ width: '100%' }}
            />
          </Form.Item>
        )}
        {currentFeeType === FeeTypes.flow && (
          <Form.Item
            label={BUSINESS_FORM_CONFIG.formItemOptions.flow.label}
            name="flow"
            rules={[
              {
                required: true,
                message: BUSINESS_FORM_CONFIG.formItemOptions.flow.message,
              },
            ]}
          >
            <NumberInput
              max={100000000}
              min={0}
              suffix={BUSINESS_FORM_CONFIG.formItemOptions.flow.suffix}
              precision={2}
              style={{ width: '100%' }}
            />
          </Form.Item>
        )}
      </Form>
      <div className={Styles.tooltip}>{BUSINESS_FORM_CONFIG.extra}</div>
      <Button className={Styles.fromBtn} onClick={getAssessmentResult}>
        {BUSINESS_FORM_CONFIG.submitText}
      </Button>
    </div>
  );
};

export default BusinessForm;
